import { defineStore } from 'pinia';
import { fetchLogs } from "@/services/ppApi";
import { useAccountStore } from '@/stores/account';
import { useUserStore, USER_SETTINGS_KEYS } from '@/stores/user';

export const useLogsStore = defineStore('logs', {
    state: () => {
        const accountStore = useAccountStore();
        const accountId = accountStore?.account?.account_id ? accountStore.account.account_id : null;
        const userLogsSettings = useUserStore().getSettings(USER_SETTINGS_KEYS.logs, accountId);

        const defaultOptions = {
            status: 'all',
            endpoint: 'all',
            method: 'all'
        };
        const defaultPagination = {
            limit: '200',
            page: 1
        };
        return {
            logs: [],
            updatingOptions: false,
            downloadLinks: {},
            loading: false,
            error: null,
            found: 0,
            defaultOptions: defaultOptions,
            options: userLogsSettings?.options ? { ...defaultOptions, ...userLogsSettings.options } : { ...defaultOptions },
            pagination: { ...defaultPagination },
            currentProspectIndex: null,
        }
    },
    getters: {
        hasDefaultOptions(state) {
            return JSON.stringify(state.options) === JSON.stringify(state.defaultOptions);
        }
    },
    actions: {
        resetLogs() {
            this.$reset();
        },
        async loadLogs() {
            this.loading = true;
            this.error = null;

            try {
                const params = this.generateOptionParams();
                const response = await fetchLogs(params);
                this.logs = response.data.requests;
                this.found = response.data.found;
                this.downloadLinks.export_url_csv = response.data.download_url || null;
            } catch (error) {
                this.logs = [];
                this.found = 0;
                this.downloadLinks = {};
                this.error = error;
            } finally {
                this.loading = false;
                this.updatingOptions = false;
            }
        },
        downloadLogs() {
            if(this.downloadLinks?.export_url_csv) {
                window.open(this.downloadLinks.export_url_csv, "_blank"); 
            }
        },
        generateOptionParams() {
            const accountStore = useAccountStore();

            return {
                account_id: accountStore.account.account_id,
                limit: this.pagination.limit,
                page: this.pagination.page,
                ...(this.options.status && this.options.status !== 'all' && { status: this.options.status }),
                ...(this.options.method && this.options.method !== 'all' && { method: this.options.method }),
                ...(this.options.endpoint && this.options.endpoint !== 'all' && { endpoint: this.options.endpoint })
            };
        },
        updateOptions(newOptions) {
            this.options = { ...this.options, ...newOptions };
            this.saveLogsSettings();
            this.pagination.page = 1;
            this.downloadLinks = {};
            this.loadLogs();
        },
        saveLogsSettings() {
            const userStore = useUserStore();
            const accountStore = useAccountStore();
            userStore.saveSettings(USER_SETTINGS_KEYS.logs, accountStore.account.account_id, { options: this.options });
        },
        setUpdatingOptions(updating) {
            this.updatingOptions = updating;
        },
        resetOptions() {
            this.options = { ...this.defaultOptions };
            this.saveLogsSettings();
            this.pagination.page = 1;
            this.downloadLinks = {};
            this.loadLogs();
        },
        updatePagination(newPagination) {
            this.pagination = { ...this.pagination, ...newPagination };
            this.loadLogs();
        }
    }
});
